import React from "react";
import { styled } from "../../../theme/styled";
import { Body } from "../../typography/Typography";

type Props = {
  severity: "info" | "warning" | "error";
  message: string;
  size?: "small" | "medium" | "large";
  id?: string;
};

export const Message = ({
  size = "medium",
  severity,
  message,
  id,
}: Props): React.JSX.Element => {
  return (
    <Wrapper severity={severity} size={size} aria-hidden="true" id={id}>
      <MessageText severity={severity} size="small">
        {message}
      </MessageText>
    </Wrapper>
  );
};

const Wrapper = styled.div<Omit<Props, "message">>((p) => {
  return {
    background: p.severity === "warning" ? "$surface-highlight" : "transparent",
    padding: p.severity === "info"
      ? ["$spacing-0", "$spacing-16"]
      : ["$spacing-8", "$spacing-16"],
    borderRadius: "$radius-small",
    marginTop: "$spacing-4",
    textAlign: p.size === "large" ? "center" : "left",
  };
});

const MessageText = styled(Body)<{ severity: Props["severity"] }>(
  (p) => {
    const color = {
      error: "$error-text",
      warning: "$on-surface-highlight",
      info: "$text-secondary",
    } as const;
    return {
      color: color[p.severity],
    };
  },
);
